import React from 'react';
export function Footer() {
  return <footer className="w-full bg-canvas px-4 py-6 text-center sm:px-6 sm:py-8" data-id="element-74" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-[0.68rem] leading-snug text-gray-500 sm:text-xs" data-id="element-75" data-mp="3gg10u7y865zr">
        Metabolismo Reset es una guía general de alimentación, organización y
        hábitos. No sustituye el diagnóstico, tratamiento ni acompañamiento de
        un profesional de la salud. Si tienes una condición diagnosticada, estás
        embarazada, en lactancia o tomas medicación, consulta con tu médico
        antes de realizar cambios importantes en tu alimentación o rutina. Los
        resultados individuales pueden variar.
      </p>
      <p className="mt-3 font-display text-[0.6rem] font-extrabold uppercase tracking-wider text-brand-deep sm:text-xs" data-id="element-76" data-mp="3lgonkhff80o6">
        Metabolismo Reset · Todos los derechos reservados
      </p>
    </footer>;
}